import { createSlice, Dispatch } from "@reduxjs/toolkit";
import {
  PRODUCTS_COMPARE,
  SECTION_GRAND_OPENING,
} from "../../../../common/constant";
import { ICompareProduct } from "../../../../components/compare/item";
import { IRootState } from "../../../../models/interface";
import { ICommonState } from "../../../../models/interface/ICommonState";
import { common, sections } from "../../../../services";
import EventServices from "../../../../services/event";
const initialState: ICommonState = {
  loading: false,
  compareProducts: [],
  viewport: {},
};

export const commonSlice = createSlice({
  name: "common",
  initialState: initialState,
  reducers: {
    setGift: (state, action) => {
      state.gift = action.payload;
    },
    setPopup: (state, action) => {
      state.popup = action.payload;
    },
    setIsCheckGrandOpeningPromotion: (state, action) => {
      state.isCheckGrandOpeningPromotion = action.payload;
    },
    setContacts: (state, action) => {
      state.contacts = action.payload;
    },
    setHeaderCategories: (state, action) => {
      state.headerCategories = action.payload;
    },
    setIsScrollToTop: (state, action) => {
      state.isScrollToTop = action.payload;
    },
    setCompareProducts: (state, action) => {
      state.compareProducts = action.payload;
    },
    setEventSetting: (state, action) => {
      state.eventSettings = action.payload;
    },
    addCompareProducts: (state, action) => {
      // if (state.compareProducts.length < MAX_PRODUCTS_COMPARE) {
      const newState = [...state.compareProducts, action.payload];

      state.compareProducts = newState;
      // } else {
      //   message.warning(
      //     `Chỉ có thể thêm tối đa ${MAX_PRODUCTS_COMPARE} sản phẩm vào so sánh!`
      //   );
      // }
    },
    resetCompareProducts: (state, action) => {
      state.compareProducts = [];
    },
    deleteCompareProduct: (state, action) => {
      state.compareProducts.splice(action.payload.index, 1);
    },

    isLoading: (state, action) => {
      state.loading = action.payload;
    },
    setViewport: (state, action) => {
      state.viewport = {
        ...state.viewport,
        [action.payload.component]: action.payload.isInViewport,
      };
    },
  },
});

export const {
  setGift,
  setPopup,
  setIsCheckGrandOpeningPromotion,
  setContacts,
  setHeaderCategories,
  setIsScrollToTop,
  setEventSetting,
  setCompareProducts,
  addCompareProducts,
  resetCompareProducts,
  deleteCompareProduct,
  isLoading,
  setViewport,
} = commonSlice.actions;

export const getGift = (id: string) => (dispatch: Dispatch) => {
  sections.getSection(id, (data, err) => {
    if (data && data.status === 200) {
      dispatch(setGift(data.data));
    }
  });
};

export const getPopup = (id: string) => (dispatch: Dispatch) => {
  sections.getSection(id, (data, err) => {
    if (
      data &&
      data.status === 200 &&
      data.data.is_actived &&
      !data.data.deleted
    ) {
      dispatch(setPopup(data.data));
    }
  });
};

export const getGrandOpeningPromotion = () => (dispatch: Dispatch) => {
  sections.getSection(SECTION_GRAND_OPENING, (data, err) => {
    if (
      data &&
      data.status === 200 &&
      data.data.is_actived &&
      !data.data.deleted
    ) {
      dispatch(setIsCheckGrandOpeningPromotion(true));
    } else {
      dispatch(setIsCheckGrandOpeningPromotion(false));
    }
  });
};

export const getContacts = () => (dispatch: Dispatch) => {
  common.getContacts((res, err) => {
    if (res && res.docs) {
      dispatch(setContacts(res.docs));
    }
  });
};

export const getHeaderCategories = (id: string) => (dispatch: Dispatch) => {
  sections.getSection(id, (rs, err) => {
    if (rs && rs.status === 200) {
      dispatch(setHeaderCategories(rs.data));
    }
  });
};

export const loadCompareProducts = () => (dispatch: Dispatch) => {
  const data = sessionStorage.getItem(PRODUCTS_COMPARE);
  let products = data ? JSON.parse(data) : null;

  if (Array.isArray(products) && products.length) {
    dispatch(setCompareProducts(products));
  }
};

export const loadEventSettings = () => async (dispatch: Dispatch) => {
  const response = await EventServices.getEventSettings();
  dispatch(setEventSetting(response));
};

export const addCompareProduct =
  (product: ICompareProduct) => async (dispatch: Dispatch) => {
    const data = sessionStorage.getItem(PRODUCTS_COMPARE);
    let products = data ? JSON.parse(data) : null;

    if (Array.isArray(products) && products.length) {
      products = [...products, product];
    } else {
      products = [product];
    }

    sessionStorage.setItem(PRODUCTS_COMPARE, JSON.stringify(products));
    dispatch(addCompareProducts(product));
  };

export const clearCompareProducts = () => (dispatch: Dispatch) => {
  sessionStorage.setItem(PRODUCTS_COMPARE, "[]");
  dispatch(resetCompareProducts([]));
};

export const removeCompareProduct = (index: number) => (dispatch: Dispatch) => {
  const data = sessionStorage.getItem(PRODUCTS_COMPARE);
  let products = data ? JSON.parse(data) : null;

  if (Array.isArray(products) && products.length) {
    products.splice(index, 1);
  }

  sessionStorage.setItem(PRODUCTS_COMPARE, JSON.stringify(products));
  dispatch(deleteCompareProduct({ index }));
};

export const getIsScrollToTop = (flag: number) => (dispatch: Dispatch) => {
  dispatch(setIsScrollToTop(flag));
};

export const setIsLoading = (loading: boolean) => (dispatch: Dispatch) => {
  dispatch(isLoading(loading));
};

export const setIsInViewport =
  (component: string, isInViewport: boolean) => (dispatch: Dispatch) => {
    dispatch(setViewport({ component, isInViewport }));
  };

export const selectGift = (state: IRootState) => state.common.gift;
export const selectPopup = (state: IRootState) => state.common.popup;
export const selectIsCheckGrandOpeningPromotion = (state: IRootState) =>
  state.common.isCheckGrandOpeningPromotion;
export const selectContacts = (state: IRootState) => state.common.contacts;
export const selectHeaderCategories = (state: IRootState) =>
  state.common.headerCategories;
export const selectCompareProducts = (state: IRootState) =>
  state.common.compareProducts;
export const selectIsScrollToTop = (state: IRootState) =>
  state.common.isScrollToTop;

export const selectIsLoading = (state: IRootState) => state.common.loading;
export const selectViewport = (state: IRootState) => state.common.viewport;

export const selectEventSettings = (state: IRootState) =>
  state.common.eventSettings;

export default commonSlice.reducer;
